module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("kXgTY"))).then(() => parcelRequire('ak2R0'));